var exports = {
  "Og": "ChannelMessages.module__messagesWrapper___TDJQeU",
  "gs": "ChannelMessages.module__scrollerContainer___TDJQeU",
  "aE": "ChannelMessages.module__bottomFade___TDJQeU",
  "yY": "ChannelMessages.module__bottomFadeStatusAtBottom___TDJQeU",
  "K9": "ChannelMessages.module__bottomFadeStatusScrolled___TDJQeU",
  "gT": "ChannelMessages.module__scrollerContent___TDJQeU",
  "lB": "ChannelMessages.module__scrollerSpacer___TDJQeU",
  "xo": "ChannelMessages.module__scrollerSpacerAfterFiller___TDJQeU",
  "pi": "ChannelMessages.module__fillerBuffer___TDJQeU",
  "CU": "ChannelMessages.module__groupSpacer___TDJQeU",
  "$P": "ChannelMessages.module__groupSpacerHalf___TDJQeU",
  "bv": "ChannelMessages.module__scrollerInner___TDJQeU",
  "eb": "ChannelMessages.module__newMessagesBar___TDJQeU",
  "mC": "ChannelMessages.module__newMessagesBarBanner___TDJQeU",
  "xp": "ChannelMessages.module__newMessagesBarBannerText___TDJQeU",
  "su": "ChannelMessages.module__newMessagesBarBannerAction___TDJQeU",
  "G6": "ChannelMessages.module__messageBottomPill___TDJQeU",
  "Sg": "ChannelMessages.module__jumpToPresentBar___TDJQeU",
  "RQ": "ChannelMessages.module__newMessagesBarText___TDJQeU",
  "As": "ChannelMessages.module__loadErrorBar___TDJQeU",
  "Ku": "ChannelMessages.module__newMessagesBarAction___TDJQeU",
  "WB": "ChannelMessages.module__unreadSlot___TDJQeU",
};

module.exports = exports;
